__turbopack_context__.v({
  "buttons": "DTPaymentModal-module__cOJuxa__buttons",
  "cardIcon": "DTPaymentModal-module__cOJuxa__cardIcon",
  "main": "DTPaymentModal-module__cOJuxa__main",
  "title": "DTPaymentModal-module__cOJuxa__title",
});
